import React from 'react';
import { Icon } from '@iconify/react';

const PageHeader = ({ 
  icon, 
  title, 
  subtitle, 
  children, // Para botões ou ações adicionais
  className = '' 
}) => {
  return (
    <div className={`mb-4 ${className}`}>
      <div className="d-flex justify-content-between align-items-end flex-wrap gap-3 mb-3">
        <div>
          <span className="d-inline-flex align-items-center fw-bold" style={{
            fontSize: '22px',
            lineHeight: 1,
            color: 'var(--dark-text-primary, #1a1a1a)'
          }}>
            <Icon icon={icon} className="me-2 text-primary" style={{ fontSize: '1em' }} />
            {title}
          </span>
          <p className="mb-0 mt-2" style={{ 
            fontSize: '14px',
            color: 'var(--dark-text-secondary, #6b7280)'
          }}>
            {subtitle}
          </p>
        </div>

        {/* Botões ou ações adicionais */}
        {children && (
          <div className="d-flex align-items-center gap-2 ms-auto">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
















